import React from "react";
import { Statistic, Table } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons/lib";
import { BacktestSel, BacktestType } from "@/features/backtest";
import { useRootSelector } from "@/infrastructure/hooks";
import moment from "moment";

export default () => {
  const strategyDrawDown = useRootSelector(BacktestSel.strategyDrawDown);

  const columns = [
    {
      title: "Net Drawdown (%)",
      dataIndex: "netDrawdownIn %",
      key: "netDrawdownIn %",
      render: (value: number) => (
        <Statistic
          value={value}
          precision={2}
          valueStyle={{ color: value > 0 ? "#3f8600" : "#cf1322" }}
          prefix={value > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
          suffix="%"
        />
      )
    },
    {
      title: "Peak Date",
      dataIndex: "peakDate",
      key: "peakDate"
    },
    {
      title: "Valley Date",
      dataIndex: "valleyDate",
      key: "valleyDate"
    },
    {
      title: "Recovery Date",
      dataIndex: "recoveryDate",
      key: "recoveryDate"
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      render: (value: number) => <Statistic value={value} precision={0} suffix={"days"} />
    }
  ];

  return <Table dataSource={formatDateTime(strategyDrawDown)} columns={columns} pagination={false} />;

  function formatDateTime(data: BacktestType.PortfolioDrawdownTable[]) {
    return data.map(e => ({
      ...e,
      peakDate: moment(e.peakDate).format("YYYY-MM-DD"),
      valleyDate: moment(e.valleyDate).format("YYYY-MM-DD"),
      recoveryDate: moment(e.recoveryDate).format("YYYY-MM-DD")
    }));
  }
};
